export var SensorMap;
(function (SensorMap) {
    SensorMap[SensorMap["right-upper-arm"] = 0] = "right-upper-arm";
    SensorMap[SensorMap["right-lower-arm"] = 1] = "right-lower-arm";
    SensorMap[SensorMap["left-upper-arm"] = 2] = "left-upper-arm";
    SensorMap[SensorMap["left-lower-arm"] = 3] = "left-lower-arm";
    SensorMap[SensorMap["torso"] = 4] = "torso";
    SensorMap[SensorMap["right-upper-leg"] = 5] = "right-upper-leg";
    SensorMap[SensorMap["right-lower-leg"] = 6] = "right-lower-leg";
    SensorMap[SensorMap["left-upper-leg"] = 7] = "left-upper-leg";
    SensorMap[SensorMap["left-lower-leg"] = 8] = "left-lower-leg";
    SensorMap[SensorMap["hip"] = 9] = "hip";
})(SensorMap || (SensorMap = {}));
export var FrameCacheMode;
(function (FrameCacheMode) {
    FrameCacheMode["Live"] = "Live";
    FrameCacheMode["Capture"] = "Capture";
    FrameCacheMode["Playback"] = "Playback";
    FrameCacheMode["CreateReport"] = "CreateReport";
    FrameCacheMode["Load"] = "Load";
    FrameCacheMode["LiveCamera"] = "LiveCamera";
    FrameCacheMode["None"] = "None";
})(FrameCacheMode || (FrameCacheMode = {}));
export var FrameType;
(function (FrameType) {
    FrameType["AnalyticsFrame"] = "Analytics";
    FrameType["ModelStateFrame"] = "ModelState";
})(FrameType || (FrameType = {}));
export var FrameCacheEvent;
(function (FrameCacheEvent) {
    FrameCacheEvent["Analytics"] = "Analytics";
    FrameCacheEvent["State"] = "State";
    FrameCacheEvent["ModelUpdate"] = "ModelUpdate";
    FrameCacheEvent["DataSetLoaded"] = "DataSetLoaded";
})(FrameCacheEvent || (FrameCacheEvent = {}));
export var Garment;
(function (Garment) {
    Garment["SHIRT"] = "shirt";
    Garment["PANT"] = "pants";
    Garment["UNKNOWN"] = "Unknown";
    Garment["None"] = "None";
})(Garment || (Garment = {}));
export var LEFT_SIDE = 0;
export var RIGHT_SIDE = 1;
export var Axis;
(function (Axis) {
    Axis[Axis["X"] = 0] = "X";
    Axis[Axis["Y"] = 1] = "Y";
    Axis[Axis["Z"] = 2] = "Z";
})(Axis || (Axis = {}));
export var X = Axis.X;
export var Y = Axis.Y;
export var Z = Axis.Z;
export var SAGITTAL = 0;
export var CORONAL = 1;
export var TRANSVERSE = 2;
export var ReportStatusEnum;
(function (ReportStatusEnum) {
    ReportStatusEnum["Normal"] = "Normal";
    ReportStatusEnum["Warning"] = "Warning";
    ReportStatusEnum["Danger"] = "Danger";
})(ReportStatusEnum || (ReportStatusEnum = {}));
export var ReportAnalyticsEnum;
(function (ReportAnalyticsEnum) {
    ReportAnalyticsEnum["GRFMax"] = "GRFMax";
    ReportAnalyticsEnum["KneeLoadMax"] = "KneeLoadMax";
    ReportAnalyticsEnum["KneeLoadMax_Monopedal"] = "KneeLoadMaxMonopedal";
    ReportAnalyticsEnum["KneeFlexionMax"] = "KneeFlexionMax";
    ReportAnalyticsEnum["KneeFlexionMax_Monopedal"] = "KneeFlexionMaxMonopedal";
    ReportAnalyticsEnum["HipKneeLoadRatioMax"] = "LumbarKneeLoadRatioMax";
    ReportAnalyticsEnum["HipLoadMax"] = "HipLoadMax";
    ReportAnalyticsEnum["HipLoadMax_Monopedal"] = "HipLoadMaxMonopedal";
    ReportAnalyticsEnum["HipExtensionMax"] = "HipExtensionMax";
    ReportAnalyticsEnum["HipFlexionMax"] = "HipFlexionMax";
    ReportAnalyticsEnum["HipFlexionMax_Monopedal"] = "HipFlexionMaxMonopedal";
})(ReportAnalyticsEnum || (ReportAnalyticsEnum = {}));
export var ReportSecondaryAnalyticsEnum;
(function (ReportSecondaryAnalyticsEnum) {
    ReportSecondaryAnalyticsEnum["DeltaPercent"] = "DeltaPercent";
    ReportSecondaryAnalyticsEnum["DeltaPercentIfPositive"] = "DeltaPercentIfPositive";
    ReportSecondaryAnalyticsEnum["DeltaAbsolute"] = "DeltaAbsolute";
})(ReportSecondaryAnalyticsEnum || (ReportSecondaryAnalyticsEnum = {}));
//# sourceMappingURL=types.js.map